export { default } from "./Triple";
